import _ from 'lodash'
import { getState } from './processPortalRules'
import { List } from 'immutable'

export const IS_DATA_CONTAINER = [
  'FormField',
  'Rating',
  'StarRating',
  'YesNo',
  'ImageChoice',
  'CES',
  'Range',
  'Ranking',
  'SurveyList',
  'Matrix',
]

export const getPageUID = function (pageID, pages) {
  let pageUID
  if (List.isList(pages)) {
    pages.map((page) => {
      if (page.get('_id') == pageID) {
        pageUID = page.get('uid')
      }
    })
  }
  return pageUID
}

export const getSurveyEmailValueByType = function (elem, urlParams) {
  let result
  let elemType = elem.get('type')
  if (elemType == 'FormField') {
    elemType = elem.getIn(['props', 'control'])
  } else if (elemType == 'Widget') {
    elemType = elem.getIn(['props', 'data', 'Type'])
    return result
  } else if (IS_DATA_CONTAINER.indexOf(elemType) == -1) {
    return result
  }
  if (!urlParams || !urlParams.value) {
    return result
  }

  switch (elemType) {
    case 'CES':
    case 'SurveyList':
      {
        let items = _.get(elem.toJS(), ['props', 'items'], [])
        let advancedItem, regularValue
        _.each(items, (row) => {
          if (row) {
            if (row.label == urlParams.value) {
              regularValue = row
            } else if (row.value == urlParams.value) {
              advancedItem = row
            }
          }
        })
        let value = advancedItem || regularValue
        result = {
          label: _.get(value, ['label'], ''),
          value: _.get(value, ['value'], ''),
        }
      }
      break
    default:
      result = urlParams.value
      break
  }

  return result
}

export const getValueByType = function (elem, pageUID, elemUID, state) {
  let result
  let elemType = elem.get('type')
  if (elemType == 'FormField') {
    elemType = elem.getIn(['props', 'control'])
  } else if (elemType == 'Widget') {
    elemType = elem.getIn(['props', 'data', 'Type'])
    if (IS_DATA_CONTAINER.indexOf(elemType) == -1) {
      return result
    }
  } else if (IS_DATA_CONTAINER.indexOf(elemType) == -1) {
    return result
  }

  let valueState = getState(state)

  let pathValue
  if (elemType == 'param') {
    pathValue = ['params', elemUID]
  } else if (elemType == 'pageParam') {
    pathValue = [pageUID, elemUID]
  } else {
    pathValue = [pageUID, elemUID]
  }

  if (elemType == 'param') {
    result = state.getIn(pathValue)
  } else {
    result = _.get(valueState, pathValue)
  }

  switch (elemType) {
    case 'Matrix': {
      if (!result || typeof result !== 'object') {
        result = undefined
      }
      break
    }
    case 'Range': {
      if (result && result.min === '' && result.max === '') {
        result = undefined
      }
      break
    }
    case 'lookup':
      {
        let val = {
          label: _.get(result, ['ft_text'], ''),
          value: _.get(result, ['ft_value'], ''),
        }
        if (val.value === '' && val.label === '') {
          result = undefined
        } else {
          result = val
        }
      }
      break
    case 'buttongroup':
    case 'CES':
    case 'SurveyList':
    case 'ImageChoice':
    case 'radio':
    case 'select':
    case 'multiSelect':
      {
        let val = {
          label: _.get(result, ['ftListLabel'], ''),
          value: _.get(result, ['ftListValue'], ''),
        }
        if (val.value === '' && val.label === '') {
          result = undefined
        } else {
          result = val
        }
      }
      break
    default:
      if (result === '') {
        result = undefined
      }
      break
  }

  return result
}
